import Pusher from 'pusher-js';

let PUSHER = undefined;

const log = function () {
  if (window && window.APP_ENV === 'development') {
    console.log(...arguments);
  }
};

const setupClient = (realtimeConfig) => {
  if (!PUSHER && realtimeConfig && realtimeConfig.key) {
    PUSHER = new Pusher(realtimeConfig.key, {
      cluster: realtimeConfig.cluster,
    });
  }
};

const subscribe = (obj, event, callback) => {
  let realtimeConfig = obj.realtime || {};

  setupClient(realtimeConfig);

  if (!PUSHER) {
    return () => {};
  }

  let handler = (data) => {
    log('[Realtime]', `| ${event} |`, data);
    callback && callback(data);
  };

  let channel = PUSHER.subscribe(realtimeConfig.channel);

  channel.bind(event, handler);

  return () => {
    channel.unbind(event, handler);
  };
};

const unsubscribe = (obj) => {
  if (PUSHER && obj && obj.realtime) {
    PUSHER.unsubscribe(obj.realtime.channel);
  }
};

export default {
  subscribe,
  unsubscribe,
};
